import { PDFDocument } from "pdf-lib";
import { TWHandleErrors } from "./handle_errors";

export class TWHandlePdf extends TWHandleErrors {
  constructor() {
    super();
  }

  // Improve errors validation
  readFile = (file: File) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      file && reader.readAsArrayBuffer(file);
    });
  };

  getNumPages = async (file: File) => {
    const arrayBuffer = await this.readFile(file);
    const $numberOfPagesInput = document.querySelector(
      "#number-of-pages"
    ) as HTMLInputElement;
    const $form = document.querySelector("#tw-print-form") as HTMLFormElement;
    const $tracker = document.querySelector("#tw_form_tracker");

    const $fileSizeNode = $form.querySelector(".upload-file-size");
    const $fileNameNode = $form.querySelector(".upload-file-name");
    const $uploadFileNode = $form.querySelector(".upload-text");
    const $numPagesNode = $tracker.querySelector(".final-quantity");
    const $priceNode = $tracker.querySelector(".final-price");
    const $notification = $tracker.querySelector(".form-tracker-notification");

    try {
      const pdf = await PDFDocument.load(arrayBuffer as any, {
        ignoreEncryption: true,
        throwOnInvalidObject: true,
      });

      const count = pdf.getPageCount();
      $numberOfPagesInput.value = count.toString();
      this.handleDisabledInputs(false);
      $notification && $notification.classList.remove("--visible");

      return count;
    } catch (error) {
      this.handleDisabledInputs(true);
      $fileSizeNode.innerHTML = "";
      $fileNameNode.innerHTML = "Carica un nuovo file";
      $uploadFileNode.innerHTML =
        '<span class="error">Spiacenti, il PDF non sembra essere valido o è corrotto</span>';
      $numPagesNode.innerHTML = "0";
      $priceNode.innerHTML = "0";
    }
  };
}

window.addEventListener("DOMContentLoaded", () => {
  new TWHandlePdf();
});
